import MemberTag from '@/components/Product/MemberTag';
import { useStore } from '@/providers/app-store-provider';
import { LensIndexItem } from '../types';
import { handleLensIndexDiscountPercent } from '../utils';

export default function LensIndexMemberTag({ lensIndexItem }: { lensIndexItem: LensIndexItem }) {
  const userInfo = useStore((state) => state.userInfo);
  if (userInfo?.is_member === 1 && handleLensIndexDiscountPercent(lensIndexItem, userInfo) <= 0) {
    return <></>;
  }
  return <MemberTag level={userInfo.member_level} />;
}
